import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleFavoritosClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('favoritos');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById('favoritos');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const handleSobreMiClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('sobre-mi');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById('sobre-mi');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="px-8 md:px-12 lg:px-[8%] py-6 flex items-center justify-between">
        <Link
          to="/"
          className="text-[28px] lg:text-[32px] font-bold text-[#222222] tracking-[-0.01em] hover:opacity-80 transition-opacity cursor-pointer"
        >
          LunaFinds<span className="text-[#EBCFD4]">.</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/explorar"
            className="text-[14px] text-[#6B6860] hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap"
          >
            Explorar
          </Link>
          <a
            href="/#favoritos"
            onClick={handleFavoritosClick}
            className="text-[14px] text-[#6B6860] hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap"
          >
            Favoritos ⭐
          </a>
          <a
            href="/#sobre-mi"
            onClick={handleSobreMiClick}
            className="text-[14px] text-[#6B6860] hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap"
          >
            Sobre Luna
          </a>
        </div>
      </div>
    </nav>
  );
}
